/* Anthology B2B header — audience state (retail | trade).
 *
 * Contract:
 * - <html data-audience="retail|trade"> is the single source of truth for
 *   CSS view switching (set pre-paint by the bootstrap script in
 *   sections/static-header.liquid, kept in sync here).
 * - Persistence: localStorage 'anthology:audience'. A companion key
 *   'anthology:audience:ctx' records whether the choice was made while
 *   signed in as a B2B company contact, so a pre-login retail preference
 *   never overrides the trade default after a B2B sign-in.
 * - Integrations: window event 'anthology:audience:change'
 *   (detail: { audience }) fires on every switch — parallel features
 *   (project lists, quick order, net-price UI) should listen for it.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'anthology:audience';
  var STORAGE_CTX_KEY = 'anthology:audience:ctx';
  var root = document.documentElement;

  function currentAudience() {
    return root.getAttribute('data-audience') === 'trade' ? 'trade' : 'retail';
  }

  function readConfig() {
    var el = document.querySelector('[data-b2b-header-config]');
    if (!el) return {};
    try {
      return JSON.parse(el.textContent) || {};
    } catch (error) {
      return {};
    }
  }

  var config = readConfig();

  function syncToggles(audience) {
    var buttons = document.querySelectorAll('[data-audience-set]');
    for (var i = 0; i < buttons.length; i++) {
      var pressed = buttons[i].getAttribute('data-audience-set') === audience;
      buttons[i].setAttribute('aria-pressed', pressed ? 'true' : 'false');
    }
  }

  function syncSearchPlaceholders(audience) {
    var placeholders = config.placeholders || {};
    var text = placeholders[audience];
    if (!text) return;
    var inputs = document.querySelectorAll(
      '[data-site-header] [data-live-search-input]'
    );
    for (var i = 0; i < inputs.length; i++) {
      inputs[i].setAttribute('placeholder', text);
    }
  }

  function persist(audience) {
    var b2bId = root.getAttribute('data-b2b-customer-id');
    try {
      localStorage.setItem(STORAGE_KEY, audience);
      localStorage.setItem(STORAGE_CTX_KEY, b2bId ? 'b2b:' + b2bId : 'guest');
    } catch (error) {
      /* Private browsing / storage disabled — view still switches. */
    }
  }

  function setAudience(audience, options) {
    audience = audience === 'trade' ? 'trade' : 'retail';
    var changed = currentAudience() !== audience;
    root.setAttribute('data-audience', audience);
    syncToggles(audience);
    syncSearchPlaceholders(audience);

    if (!options || options.persist !== false) {
      persist(audience);
    }

    if (changed) {
      if (!options || options.persist !== false) {
        root.setAttribute('data-audience-animate', 'true');
      }
      try {
        window.dispatchEvent(
          new CustomEvent('anthology:audience:change', {
            detail: { audience: audience }
          })
        );
      } catch (error) {
        /* CustomEvent unavailable — no subscribers to notify. */
      }
    }
  }

  function onReady() {
    document.addEventListener('click', function (event) {
      var button = event.target.closest
        ? event.target.closest('[data-audience-set]')
        : null;
      if (!button) return;
      setAudience(button.getAttribute('data-audience-set'));
    });

    document.addEventListener('click', function (event) {
      var pickers = document.querySelectorAll('[data-trade-location-picker][open]');
      for (var i = 0; i < pickers.length; i++) {
        if (!pickers[i].contains(event.target)) {
          pickers[i].removeAttribute('open');
        }
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape' && event.key !== 'Esc') return;
      var pickers = document.querySelectorAll('[data-trade-location-picker][open]');
      for (var i = 0; i < pickers.length; i++) {
        pickers[i].removeAttribute('open');
        var summary = pickers[i].querySelector('summary');
        if (summary && pickers[i].contains(document.activeElement)) {
          summary.focus();
        }
      }
    });

    setAudience(currentAudience(), { persist: false });
  }

  window.AnthologyAudience = {
    get: currentAudience,
    set: function (audience) {
      setAudience(audience);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }
})();
